// Module 10.6 — prosumer battery + solar visuals (§8). socFrac → bar height; sign of batteryMw →
// charge/discharge/idle mode; solarMw>0 → solar glow. Driven purely by per-prosumer ProsumerRuntime
// (v2 optional Snapshot detail); absent runtime ⇒ no prosumer drawn (v1-shaped snapshot, not an error).
import type { Load, ProsumerRuntime } from "../../domain/index";
import type { ProsumerSpec, BatteryMode } from "./spec";
import { FUEL_COLOR } from "./palette";

export function encodeProsumers(
  runtimes: readonly ProsumerRuntime[] | undefined,
  loadById: ReadonlyMap<string, Load>,
): ProsumerSpec[] {
  if (!runtimes || runtimes.length === 0) return [];
  const out: ProsumerSpec[] = [];
  for (const r of runtimes) {
    const l = loadById.get(r.id as string);
    const mode: BatteryMode = r.batteryMw > 0 ? "discharge" : r.batteryMw < 0 ? "charge" : "idle";
    out.push({
      id: r.id as string,
      coord: l ? l.coord : { lat: 0, lon: 0 },
      socFrac: r.socFrac,
      batteryMode: mode,
      batteryColor: FUEL_COLOR.BATTERY,
      batteryMotion: mode === "idle" ? "steady" : "pulse",
      solarGlow: r.solarMw > 0,
    });
  }
  return out;
}
